/**
 * Patch per aggiungere badge 3 bottiglie (quantity discount) ai Recently Viewed
 * Sovrascrive window.ShopifyStorefront.productQuery e productCardMarkup
 * senza modificare il file storefront-api.js minificato
 */

(function() {
  'use strict';

  // SVG 3 bottiglie (quantity discount badge) - con stili inline per dimensione corretta
  const QTY_DISC_SVG = `<svg width="220" height="241" viewBox="0 0 220 241" fill="none" xmlns="http://www.w3.org/2000/svg" style="height: auto; left: 17px; position: absolute; top: 15px; transform: rotate(-45deg); width: 20px;">
    <path d="M50.3735 0.167838C50.3735 0.167838 42.9554 1.15062 43.8456 6.45756C44.7357 11.7647 44.5379 19.9215 44.0434 21.8871C43.5488 23.8526 42.7575 26.8993 43.9445 28.2751C45.1314 29.6511 45.1324 32.1286 45.1324 32.1286C48.1826 72.539 34.4566 113.202 28.1019 132.144C21.7473 151.087 22.0014 166.746 22.0014 166.746V230.699C22.0014 240.855 34.2023 241 34.2023 241H78.1583C78.1583 241 90.3592 240.855 90.3592 230.699V166.746C90.3592 166.746 90.6135 151.087 84.2588 132.144C77.9042 113.202 64.1781 72.539 67.2283 32.1286C67.2283 32.1286 67.2294 29.6511 68.4163 28.2751C69.6031 26.8993 68.8118 23.8526 68.3174 21.8871C67.8228 19.9215 67.6249 11.7647 68.5152 6.45756C69.4054 1.15062 61.9873 0.167838 61.9873 0.167838C61.9873 0.167838 54.0202 -0.209798 50.3735 0.167838Z" fill="#42D2AB"/>
    <path d="M103.734 0.167838C103.734 0.167838 96.316 1.15062 97.2062 6.45756C98.0963 11.7647 97.8985 19.9215 97.404 21.8871C96.9094 23.8526 96.1181 26.8993 97.3051 28.2751C98.492 29.6511 98.493 32.1286 98.493 32.1286C101.543 72.539 87.8172 113.202 81.4625 132.144C75.1079 151.087 75.362 166.746 75.362 166.746V230.699C75.362 240.855 87.5629 241 87.5629 241H131.519C131.519 241 143.72 240.855 143.72 230.699V166.746C143.72 166.746 143.974 151.087 137.619 132.144C131.265 113.202 117.539 72.539 120.589 32.1286C120.589 32.1286 120.59 29.6511 121.777 28.2751C122.964 26.8993 122.172 23.8526 121.678 21.8871C121.183 19.9215 120.985 11.7647 121.876 6.45756C122.766 1.15062 115.348 0.167838 115.348 0.167838C115.348 0.167838 107.381 -0.209798 103.734 0.167838Z" fill="#90DFCA"/>
    <path d="M157.095 0.167838C157.095 0.167838 149.677 1.15062 150.567 6.45756C151.457 11.7647 151.259 19.9215 150.765 21.8871C150.27 23.8526 149.479 26.8993 150.666 28.2751C151.853 29.6511 151.854 32.1286 151.854 32.1286C154.904 72.539 141.178 113.202 134.823 132.144C128.468 151.087 128.723 166.746 128.723 166.746V230.699C128.723 240.855 140.923 241 140.923 241H184.879C184.879 241 197.08 240.855 197.08 230.699V166.746C197.08 166.746 197.335 151.087 190.98 132.144C184.625 113.202 170.899 72.539 173.949 32.1286C173.949 32.1286 173.951 29.6511 175.137 28.2751C176.324 26.8993 175.533 23.8526 175.039 21.8871C174.544 19.9215 174.346 11.7647 175.236 6.45756C176.127 1.15062 168.708 0.167838 168.708 0.167838C168.708 0.167838 160.741 -0.209798 157.095 0.167838Z" fill="white"/>
  </svg>`;

  function initPatch() {
    // Aspetta che ShopifyStorefront sia disponibile
    if (!window.ShopifyStorefront) {
      setTimeout(initPatch, 50);
      return;
    }

    // Aspetta che le funzioni siano definite
    if (!window.ShopifyStorefront.productQuery || !window.ShopifyStorefront.productCardMarkup) {
      setTimeout(initPatch, 50);
      return;
    }

    console.log('[Recently Viewed Patch] Inizializzazione...');

    // ========================================
    // 1. PATCH QUERY: Aggiungi 'tags' alla GraphQL query
    // ========================================
    const originalProductQuery = window.ShopifyStorefront.productQuery;
    window.ShopifyStorefront.productQuery = function(options) {
      const originalQuery = originalProductQuery(options);
      // Aggiungi 'tags' alla fine della query
      return originalQuery + '\ntags';
    };

    // ========================================
    // 2. PATCH RENDERING: Badge 3 bottiglie per qty_disc
    // ========================================
    const originalProductCardMarkup = window.ShopifyStorefront.productCardMarkup;
    window.ShopifyStorefront.productCardMarkup = function(options) {
      const { node } = options;
      
      // DEBUG: Log SEMPRE per vedere se viene chiamato
      console.log('[Recently Viewed Patch] 🔍 productCardMarkup chiamato per:', node.title, '| Tutti i tags:', node.tags);
      
      // Check tag quantity discount
      const hasQtyDiscountTag = node.tags && Array.isArray(node.tags) && 
                                node.tags.some(tag => tag.startsWith('_qty_disc_'));
      
      // DEBUG: Log del prodotto e tags
      if (node.tags && node.tags.length > 0) {
        console.log('[Recently Viewed Patch] Prodotto:', node.title, '| Tags:', node.tags, '| Ha qty_disc?', hasQtyDiscountTag);
      }
      
      // Ottieni HTML originale
      let html = originalProductCardMarkup(options);
      
      // Se ha qty_disc, aggiungi badge 3 bottiglie
      if (hasQtyDiscountTag) {
        // Badge SVG con inline styles forzati (come fixBadgesPositioning in algolia-collection.js)
        const svgBadge = `<span class="discount-badge discount-badge-xtrawine" style="position: absolute; top: 8px; left: 8px; z-index: 25; display: flex; visibility: visible; opacity: 1; width: 55px; height: 55px;">${QTY_DISC_SVG}</span>`;
        const tooltip = `<div class="discount-badge_tooltip"><span>Quantity Discount</span></div>`;
        
        // Cerca wishlist-button e inserisci badge PRIMA
        // Questo è il punto esatto dove appare nelle collections
        const wishlistPattern = /(\s*)(<wishlist-button)/;
        
        if (wishlistPattern.test(html)) {
          // Sostituisci badge esistente SE c'è, altrimenti aggiungi
          const hasBadge = /<span class="discount-badge">/.test(html);
          if (hasBadge) {
            html = html.replace(
              /<span class="discount-badge">[\s\S]*?<\/span>/,
              svgBadge + '\n                ' + tooltip
            );
            console.log('[Recently Viewed Patch] ✅ Badge percentuale sostituito con SVG per:', node.title);
          } else {
            // Inserisci badge + tooltip PRIMA di wishlist-button
            html = html.replace(
              wishlistPattern,
              `\n                ${svgBadge}\n                ${tooltip}$1$2`
            );
            console.log('[Recently Viewed Patch] ✅ Badge SVG aggiunto (no badge percentuale) per:', node.title);
          }
        } else {
          console.log('[Recently Viewed Patch] ⚠️ wishlist-button non trovato in:', node.title);
        }
      }
      
      return html;
    };

    console.log('[Recently Viewed Patch] ✅ Patch attivo - productQuery e productCardMarkup sovrascritti');
  }

  // Avvia IMMEDIATAMENTE (non aspettare DOMContentLoaded)
  // Questo garantisce che il patch sia attivo PRIMA di recently-viewed-component.js
  initPatch();
})();
